// Footer

export function Footer() {
  return (
    <footer>
      <small>Isaac Olarewaju, 2026.</small>
      <small></small>
    </footer>
  );
}
